/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState } from "react";
import "./Nav.css";
import { Col, Container, Dropdown, Offcanvas, Row } from "react-bootstrap";
import { AiOutlineMenu } from "react-icons/ai";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { sidebarItems } from "./SidebarData";
import DeleteModel from "../../../components/DeleteModel";
import logo from "../../../assets/images/logo.webp";
import { Menu } from "antd";
import { clearAllLocalStorage } from "../../../constants/localStorage";
import { app_Name } from "../../../constants/helpers";
import { useRole } from "../../../hooks/useRole";
import { primaryColor } from "../../../constants/colors";
import { BoxArrowRight, PersonCircle } from "react-bootstrap-icons";

const { SubMenu } = Menu;
const MainNav = () => {
  const { color } = "#ffffff";
  const [show, setShow] = useState(false);
  const [logoutShow, setLogoutShow] = useState(false);
  const [openKeys, setOpenKeys] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const { user: currentUser } = useRole();

  const handleClose = () => setShow(false);
  const handleNavigateAddForm = () => setShow(true);
  const handleModelClose = () => setLogoutShow(false);

  const handleLogout = () => {
    clearAllLocalStorage();
    navigate("/adminlogin");
    window.location.reload();
  };

  const findSelectedKey = (items, path) => {
    for (const item of items) {
      if (item.url === path) {
        return item.id.toString();
      }
      if (item.children) {
        const childKey = findSelectedKey(item.children, path);
        if (childKey) {
          return childKey;
        }
      }
    }
    return null;
  };

  const selectedKey = findSelectedKey(sidebarItems, location.pathname);

  useEffect(() => {
    const findParentKey = (items, path) => {
      for (const item of items) {
        if (item.url === path) {
          return item.id.toString();
        }
        if (item.children) {
          const childKey = findParentKey(item.children, path);
          if (childKey) {
            return item.id.toString();
          }
        }
      }
      return null;
    };

    const parentKey = findParentKey(sidebarItems, location.pathname);
    if (parentKey) {
      setOpenKeys([parentKey]);
    }
  }, [location.pathname]);

  const onOpenChange = (keys) => {
    setOpenKeys(keys);
  };
  const filteredSidebarItems = React.useMemo(() => {
    if (!currentUser) {
      return [];
    }
    if (currentUser.role === "superadmin") {
      return sidebarItems;
    }
    return sidebarItems.filter((item) => {
      if (item.module === "adminList" && currentUser.role !== "superadmin") {
        return false;
      }
      if (currentUser.role) {
        return currentUser.permissions.includes(item.module);
      }
      return true;
    });
  }, [currentUser]);

  if (!currentUser) {
    return <div>Loading...</div>;
  }

  console.log(currentUser);

  return (
    <>
      <Container
        fluid
        className="d-flex flex-row flex-wrap-wrap justify-content-between align-items-center overflowX-hidden"
        style={{
          position: "sticky",
          top: "0",
          zIndex: 1000,
          backgroundColor: "#ffffff",
          borderBottom: "2px solid #e9edf4",
        }}
      >
        <Row className="d-flex flex-row flex-wrap-wrap justify-content-around align-items-center p-2">
          <Col className="d-lg-none d-xl-none d-sm-flex">
            <AiOutlineMenu
              size={25}
              onClick={handleNavigateAddForm}
              className="pointer"
              color="#515b73"
            />
          </Col>
          <Col
            className="d-lg-flex d-none d-sm-none flex-row flex-wrap-wrap justify-content-between align-items-center"
            style={{ marginRight: "100px" }}
          >
            <img
              src={logo}
              width={45}
              className="pointer"
              alt="MainLogoImage1"
              title="MainLogoImage1"
            />
          </Col>
        </Row>
        {/* mobile view */}

        <Row>
          <Col className='d-lg-none d-sm-flex flex-row flex-wrap-wrap justify-content-between" align-items-center'>
            <img
              src={logo}
              width={50}
              className="p-2 pointer rounded-circle"
              alt="MainLogoImage2"
              title="MainLogoImage2"
            />
          </Col>
        </Row>

        <Row className="d-flex mt-1">
          {/* lap view */}
          <Col className="d-flex  flex-row flex-wrap-wrap justify-content-center align-items-center position-relative">
            <div className="d-flex align-items-center position-relative">
              <Dropdown align="end">
                <Dropdown.Toggle
                  id="user-dropdown"
                  variant="light"
                  className="bg-transparent border-0 p-1"
                >
                  <PersonCircle size={32} color={primaryColor} />
                </Dropdown.Toggle>

                <Dropdown.Menu
                  className="shadow-sm"
                  style={{ minWidth: "250px" }}
                >
                  {/* User Info Section */}
                  <div className="px-4 py-3 border-bottom">
                    <div className="d-flex align-items-center mb-2">
                      <PersonCircle size={36} className="text-primary me-2" />
                      <div>
                        <div className="fw-bold">{currentUser.name}</div>
                        <small className="text-muted">{currentUser.role}</small>
                      </div>
                    </div>
                    <small className="text-muted d-block text-truncate">
                      {currentUser.email}
                    </small>
                    {currentUser?.branch && (
                      <small className="text-muted d-block text-truncate">
                        {currentUser?.branch?.branchName}
                      </small>
                    )}
                  </div>

                  <Dropdown.Item
                    className="d-flex align-items-center py-2 text-danger"
                    onClick={() => setLogoutShow(true)}
                  >
                    <BoxArrowRight size={16} className="me-2" />
                    <span>Logout</span>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Conditionally render Offcanvas for large screens */}
      <Row className="d-none d-lg-flex">
        <Offcanvas scroll={false} show={show} onHide={handleClose}>
          <Offcanvas.Header style={{ backgroundColor: color }} closeButton>
            <Offcanvas.Title
              className="custom-title"
              style={{
                fontSize: "16px",
                color: "#515b73",
              }}
            >
              <img
                src={logo}
                width={50}
                className="rounded-circle p-2"
                alt="image"
              />
              <span className="fw-bolder" style={{ fontSize: "12px" }}>
                {app_Name}
              </span>
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body style={{ backgroundColor: " #FFFFFF" }}>
            {!currentUser ? (
              <div>Loading...</div>
            ) : (
              <Menu
                mode="inline"
                openKeys={openKeys}
                onOpenChange={onOpenChange}
                selectedKeys={[selectedKey]}
                style={{ height: "100%", borderRight: 0 }}
                theme="light"
              >
                {filteredSidebarItems.map((menu) =>
                  menu.children && menu.children.length > 0 ? (
                    <SubMenu
                      key={menu.id}
                      icon={menu.icon}
                      style={{
                        color:
                          selectedKey === menu.id.toString() ||
                          menu.children.some(
                            (child) => selectedKey === child.id.toString()
                          )
                            ? "var(--primary-color)"
                            : "#6d758a",
                        backgroundColor:
                          selectedKey === menu.id.toString() ||
                          menu.children.some(
                            (child) => selectedKey === child.id.toString()
                          )
                            ? "#E5D6F3"
                            : "#ffffff",
                      }}
                      title={
                        <span style={{ color: "#6d758a" }}>{menu.label}</span>
                      }
                    >
                      {menu.children.map((item) => (
                        <Menu.Item
                          key={item.id}
                          icon={item.icon}
                          style={{
                            color:
                              selectedKey === item.id.toString()
                                ? "var(--primary-color)"
                                : "#6d758a",
                            backgroundColor:
                              selectedKey === item.id.toString()
                                ? "#E5D6F3"
                                : "#ffffff",
                          }}
                        >
                          <Link
                            className="link-unstyled"
                            onClick={handleClose}
                            to={item.url}
                          >
                            {item.label}
                          </Link>
                        </Menu.Item>
                      ))}
                    </SubMenu>
                  ) : (
                    <Menu.Item
                      key={menu.id}
                      icon={menu.icon}
                      style={{
                        color:
                          selectedKey === menu.id.toString()
                            ? "var(--primary-color)"
                            : "#6d758a",
                        backgroundColor:
                          selectedKey === menu.id.toString()
                            ? "#e0dee2"
                            : "#ffffff",
                        fontWeight:
                          selectedKey === menu.id.toString() ? "600" : "",
                      }}
                    >
                      <Link
                        className="link-unstyled"
                        onClick={handleClose}
                        to={menu.url}
                      >
                        {menu.label}
                      </Link>
                    </Menu.Item>
                  )
                )}
              </Menu>
            )}
          </Offcanvas.Body>
        </Offcanvas>
      </Row>

      <DeleteModel
        DELETESTATE={logoutShow}
        ONCLICK={handleModelClose}
        YES={handleLogout}
        DESCRIPTION="Do You Want To Logout"
        DELETETITLE="Logout"
      />
    </>
  );
};

export default MainNav;
